import Vue from 'vue'
import Router from 'vue-router'
import {Auth} from '@/services'
import {
	loginPage,
	loginFirstAccessPage,
	loginFormPage,
	loginAuthorize,

	patientPanelPage,
	patientExamsPage, 
	patientExamViewPage,
	patientAccountPage,
	patientClinicContactPage,

	checkinPage
} from '@/pages';

Vue.use(Router)

let router = new Router({
	routes: [
		{
			path: '/',
			redirect: '/login/protocolo'
		},
		{
			path: '',
			redirect: '/login/protocolo'
		},
		{
			path: '/checkin/:data',
			name: "checkIn",
			component: checkinPage
		},		
		{
			path: '/login',
			//name: 'loginPage',
			component: loginPage,
			children: [
				{
					path: 'protocolo',
					name: 'loginFirstAccess',
					component: loginFirstAccessPage
				},
				{
					path: '',
					name: 'loginForm',
					component: loginFirstAccessPage
				},
				{
					path: 'authorize/:authorizationToken',
					name: 'loginAuthorize',
					component: loginAuthorize
				}
			]
		},
		{
			path:'/panel',
			component: patientPanelPage,
			meta: {
				requiresAuth: true
			},
			children: [
				{
					path: 'exams',
					name: 'patientExams',
					component: patientExamsPage
				},
				{
					path: 'exam/:examId',
					name: 'patientExamView',
					component: patientExamViewPage
				},
				{
					path: 'my-account',
					name: 'patientAccount',
					component: patientAccountPage
				},
				{
					path: 'contact',
					name: 'patientClinicContact',
					component: patientClinicContactPage
				},
			]
		}
	]
})

router.beforeEach((to, from, next) => {
	let currentUser = Auth.isAuthenticated(),
		requiresAuth = to.matched.some(record => record.meta.requiresAuth)

		console.log("##", currentUser, requiresAuth);

	if (requiresAuth && !currentUser) next('/login')
	else next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js